var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useState } from 'react';
import { Chip, Slider, Styler, TypographyBody, usePrevious } from '@honeycomb/ui-core';
import { applyFormatString } from './utils';
import { useDebounce } from '../../utils/useDebounce';
import { FilterAccordion } from './FilterAccordion';
export function SliderRangeFilter(_a) {
    var { id, min, max, lower: lowerProp, upper: upperProp, heading, subHeading, step = 1, formatString, onChange, leadingText } = _a, other = __rest(_a, ["id", "min", "max", "lower", "upper", "heading", "subHeading", "step", "formatString", "onChange", "leadingText"]);
    const [lower, setLower] = useState(lowerProp);
    const [upper, setUpper] = useState(upperProp);
    const prevLowerProp = usePrevious(lowerProp);
    const prevUpperProp = usePrevious(upperProp);
    const debouncedOnChange = useDebounce(({ newLower, newUpper, group }) => {
        onChange(newLower, newUpper, group);
    }, 500);
    const handleChange = (_event, newValue) => {
        const [newLower, newUpper] = newValue;
        if (newLower !== lower || newUpper !== upper) {
            setLower(newLower);
            setUpper(newUpper);
            debouncedOnChange({ newLower, newUpper, group: id });
        }
    };
    useEffect(() => {
        if (lowerProp !== prevLowerProp) {
            setLower(lowerProp);
        }
        if (upperProp !== prevUpperProp) {
            setUpper(upperProp);
        }
    }, [lowerProp, upperProp, prevLowerProp, prevUpperProp]);
    const formatLabel = useCallback((value) => applyFormatString(value, formatString), [formatString]);
    const customHeading = (React.createElement(Styler, null,
        React.createElement("span", null, heading),
        subHeading && (React.createElement(TypographyBody, { component: "span", size: "xs" }, ` (${subHeading})`))));
    return (React.createElement(FilterAccordion, Object.assign({ id: id, heading: customHeading }, other),
        leadingText && React.createElement(TypographyBody, { mb: 2 }, leadingText),
        React.createElement(Styler, { display: "flex", justifyContent: "center", mb: 1 },
            React.createElement(Chip, { color: "neutral" },
                React.createElement("strong", null, formatLabel(lower)),
                " - ",
                React.createElement("strong", null, formatLabel(upper)))),
        React.createElement(Slider, { step: step, min: min, max: max, points: [
                {
                    value: min,
                    label: formatLabel(min),
                },
                {
                    value: max,
                    label: formatLabel(max),
                },
            ], value: [lower, upper], onChange: handleChange, valueText: (value, index) => {
                return index === 0 ? `from ${formatLabel(value)}` : `to ${formatLabel(value)}`;
            }, "data-id": "filter-slider" })));
}
